import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import {
	PaymentMethodSettingApi,
	PaymentMethodTPayPaymentsApi,
} from "../../../../../../../../../../services/Api/Organization/types";
import PaymentMethodForm from "../../components/PaymentMethodForm";

const OrganizationSettingsPaymentMethodsNewPage = (): JSX.Element => {
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { addFlash } = useFlash();
	const [settings, setSettings] = useState<PaymentMethodSettingApi[] | undefined>();
	const [tPayPayments, setTPayPayments] = useState<PaymentMethodTPayPaymentsApi | undefined>();

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
		fetchTPayPayments();
	}, [settings]);

	const init = async () => {
		handleChangeTabTitle(t("modules.payment_method.header.new.title"));
		await fetchPaymentMethodSettings();
	};

	const fetchPaymentMethodSettings = async () => {
		try {
			const res = await apiOrganization.getPaymentMethodSettings();
			setSettings(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchTPayPayments = async () => {
		try {
			const res = await apiOrganization.getTPayPayments();
			setTPayPayments(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!settings) return <LoadingContainer />;

	return (
		<>
			<Header title={t("modules.payment_method.header.new.title")} />
			<PaymentMethodForm settings={settings} setTPayPayments={setTPayPayments} tPayPayments={tPayPayments} />
		</>
	);
};

export default OrganizationSettingsPaymentMethodsNewPage;
